import { Box, HStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

import { DELIVERY_PROGRESS_COLOR } from './constants';

export const StatusMessage = withTypography({
  variant: 'copyTwo',
  fontSize: 'sm',
  color: primitive.$greyOne,
});

export const StatusMessageContainer = Box.withConfig({
  focusable: true,
});

export const ProgressList = HStack.withConfig({
  justifyContent: 'space-between',
  marginTop: '$5',
  marginBottom: '$4',
  width: 'full',
});

export const ProgressListItem = Box.withConfig({
  width: '70px',
  alignItems: 'center',
  _text: {
    color: primitive.$greyTwo,
    fontSize: 'xs',
    lineHeight: 'xs',
    textAlign: 'center',
  },
  focusable: true,
});

export const ProgressListItemHeader = ProgressListItem.withConfig<{ isActive?: boolean }>(p => ({
  _text: {
    color: p.isActive ? DELIVERY_PROGRESS_COLOR : primitive.$bbqBrown,
  },
}));
